import { queryOptions } from '@tanstack/react-query';
import type {
  TranslateConfigResponse,
  UserProfile,
  UserSettings,
} from '@translate-ai/shared';
import { apiFetch } from './client';

export const QK = {
  me: ['me'] as const,
  meUsage: ['me', 'usage'] as const,
  settings: ['settings'] as const,
  history: (limit: number) => ['history', limit] as const,
  historyAll: ['history'] as const,
  adminPrompts: ['admin', 'prompts'] as const,
  adminButtons: ['admin', 'buttons'] as const,
  adminCheckboxes: ['admin', 'checkboxes'] as const,
  translateConfig: ['translate', 'config'] as const,
  adminModels: ['admin', 'models'] as const,
  adminUsers: (search: string, role: string) =>
    ['admin', 'users', search, role] as const,
  adminUsersAll: ['admin', 'users'] as const,
  adminGlobals: ['admin', 'globals'] as const,
  lists: ['lists'] as const,
  list: (id: string) => ['list', id] as const,
  listAny: ['list'] as const,
  itemLists: (translationId: string) => ['itemLists', translationId] as const,
};

// Shared query definitions (key + fn + retry policy) for the requests that are
// both consumed by hooks and prefetched at startup, so the two paths can never
// drift apart. See prefetch.ts for the startup side.

export const meQuery = queryOptions({
  queryKey: QK.me,
  queryFn: () => apiFetch<UserProfile>('/me'),
  retry: (count, err) => {
    if ((err as { status?: number }).status === 401) return false;
    return count < 1;
  },
});

export const settingsQuery = queryOptions({
  queryKey: QK.settings,
  queryFn: () => apiFetch<UserSettings>('/settings'),
});

export const translateConfigQuery = queryOptions({
  queryKey: QK.translateConfig,
  queryFn: () => apiFetch<TranslateConfigResponse>('/translate/config'),
});
